import axios from "../api";

export const getBookImage = async (bookid) => {
  return await axios.get(`images/?listing_id=${bookid}`);
};
